import { useTranslation } from 'react-i18next';
import PmParcel from 'interfaces/PmParcel';
import { PickUpLocationContainer, Title } from './PickUpLocation.styles';

interface PickUpLocationProps {
  className?: string;
  shipment: PmParcel;
}

export const PickUpLocation = ({
  className,
  shipment,
}: PickUpLocationProps): JSX.Element => {
  const { t } = useTranslation();

  const pickupPoint = shipment.customFields?.find(
    ({ key }) => key === 'pickup_point',
  )?.value;

  if (!pickupPoint) {
    return null;
  }

  return (
    <PickUpLocationContainer className={className}>
      <Title>{t('PICK_UP_POINT')}</Title>
      {pickupPoint}
    </PickUpLocationContainer>
  );
};
